import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { defaultPagingSchema } from '../../../helpers/schemas/defaultPagingSchema';
import { serviceSettingsRoute } from '../route';

import {
	DEFAULT_OPERATION_STATUS,
	internalControlsFilterFormSchema,
} from './InternalControlsFilter/InternalControlsFilterFormSchema';

const internalControlsValidateSearchSchema = defaultPagingSchema.extend({
	openedControl: z.string().optional().catch(undefined),
	filter: internalControlsFilterFormSchema
		.optional()
		.catch({ operationStatus: DEFAULT_OPERATION_STATUS }),
});

export type InternalControlsValidateSearch = z.infer<
	typeof internalControlsValidateSearchSchema
>;

export const internalControlsRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/internal-controls',
	component: lazyRouteComponent(
		() => import('./InternalControlsPage'),
		'InternalControlsPage',
	),
	validateSearch: internalControlsValidateSearchSchema,
});
